import React, { useState, useEffect } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { colors } from "@mui/material";
import successImg from "../../assets/images/userprofile/successImg.png";
import { axiosInstance_user } from "../../axiosInstance-user";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper", //box color
  border: "1px solid white", //box border
  boxShadow: 24,
  pt: 2,
  px: 0,
  pb: 3,
};
// const basicSchema = Yup.object().shape({
//   place_of_birth: Yup.string().required("Place of birth is required"),
//   state_of_birth: Yup.string().required("State of birth is required"),
//   religion: Yup.string().required("Religion is required"),
//   caste: Yup.string().required("Caste is required"),
// });


const basicSchema = (initialStateId, initialReligionId, initialCasteId,subcaste) =>
  Yup.object().shape({
    state_of_birth: Yup.string().required("State of birth is required"),

    place_of_birth: Yup.string().when("state_of_birth", {
      is: (state_of_birth) => state_of_birth !== initialStateId,
      then: (schema) => schema.required("Place of birth is required when state is changed"),
      otherwise: (schema) => schema.notRequired(),
    }),

    religion: Yup.string().required("Religion is required"),

    caste: Yup.string().when("religion", {
      is: (religion) => religion !== initialReligionId,
      then: (schema) => schema.required("Caste is required when religion is changed"),
      otherwise: (schema) => schema.notRequired(),
    }),
    sub_caste: Yup.string().when("caste", {
      is: (caste) =>
        caste &&
        caste !== initialCasteId &&
        subcaste[caste] &&
       subcaste[caste].length > 0, // only require if subcastes dropdown exist
      then: (schema) =>
        schema.required("Sub Caste is required when caste has subcastes"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });


export function BasicDetails() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const userId = location.state?.id;
  console.log("userId", userId);

  const [stateId, setStateId] = useState();
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);

  const [religion, setReligion] = useState([]);
  const [religionId, setReligionId] = useState();
  const [casteId, setCasteId] = useState();
  const [caste, setCaste] = useState([]);
  const [subcaste, setSubCaste] = useState([]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
// states to show error when ever state,religion,caste fields edited
  const [initialStateId, setInitialStateId] = useState("");
const [initialReligionId, setInitialReligionId] = useState("");
const [initialCasteId, setInitialCasteId] = useState("");

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      gender: "",
      email: "",
      mobile: "",
      state_of_birth: "",
      place_of_birth: "",
      rasi: "",
      nakshatra: "",
      religion: "",
      caste: "",
      sub_caste: "",
      gotra: "",
      manglik: "",
      height: "",
      weight: "",
    },
     validationSchema: basicSchema(initialStateId, initialReligionId, initialCasteId,subcaste),
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        setLoading(true);
        const formData = new FormData();

        // Basic fields
        formData.append("first_name", values.first_name);
        formData.append("last_name", values.last_name);
        formData.append("gender", values.gender);
        formData.append("email", values.email);
        formData.append("mobile", values.mobile);
        formData.append("password", "nathicharami");

        // Profile fields
        formData.append("profile[rasi]", values.rasi || "");
        formData.append("profile[nakshatra]", values.nakshatra || "");
        formData.append("profile[gotra]", values.gotra || "");
        formData.append("profile[height]", values.height || "");
        formData.append("profile[weight]", values.weight || "");
        formData.append("profile[manglik]", values.manglik || "");
        formData.append("profile[state_of_birth]", values.state_of_birth || "");
        formData.append("profile[place_of_birth]", values.place_of_birth || "");
        formData.append("profile[religion]", values.religion || "");
        formData.append("profile[caste]", values.caste || "");
        formData.append("profile[sub_caste]", values.sub_caste || 1);

        const response = await axiosInstance_user.patch(
          `/users-profiles/${userId}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status === "success") {
          setLoading(false); // Stop loader
          console.log("Profile updated successfully");
          handleOpen();
          setTimeout(() => {
            handleClose();
          }, 2000);
          LoadUserProfile(userId);
        } else {
          console.error("Update failed", response.data);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "");
        console.error("Error while updating:", error);
      } finally {
        setLoading(false);
      }
    },
  });
  // get user data
  async function LoadUserProfile(userId) {
    try {
      const response = await axiosInstance_user.get(
        `/users-profiles/${userId}`
      );
      if (response.data.status === "success") {
        // getting few fields from user and few from profile
        const user = response.data.data;
        const profile = user.profile || {};

        // selected dropdown data loads first
        if (profile?.state_of_birth) {
          LoadCity(profile.state_of_birth); // load place_of_birth list
        }
        if (profile?.religion) {
          LoadCaste(profile.religion); // load caste list
        }

        if (profile?.caste) {
          LoadSubCaste(profile.caste); // load sub caste list
        }
         // store initial IDs for validation schema
      setInitialStateId(profile.state_of_birth || "");
      setInitialReligionId(profile.religion || "");
      setInitialCasteId(profile.caste || "");

        formik.setValues({
          first_name: user.first_name || "",
          last_name: user.last_name || "",
          gender: user.gender?.toString() || "",
          email: user.email || "",
          mobile: user.mobile || "",
          state_of_birth: profile.state_of_birth || "",
          place_of_birth: profile.place_of_birth || "",

          rasi: profile.rasi || "",
          nakshatra: profile.nakshatra || "",
          religion: profile.religion || "",
          caste: profile.caste || "",
          sub_caste: profile.sub_caste || "",
          gotra: profile.gotra || "",
          manglik: profile.manglik || "",
          height: profile.height || "",
          weight: profile.weight || "",
          password: "nathicharami", // required field
        });

        // OPTIONAL: Set dependent dropdown triggers
        // if (profile.state_of_birth) setStateId(profile.state_of_birth);
        // if (profile.religion) setReligionId(profile.religion);
        // if (profile.caste) setCasteId(profile.caste);
      }
    } catch (err) {
      console.error("Failed to load profile:", err);
    }
  }

  useEffect(() => {
    if (userId) {
      LoadUserProfile(userId);
    }
  }, [userId]);
  async function LoadState() {
    try {
      const response = await axiosInstance_user.get("/dropdown/states");
      const data = response.data;
      console.log("State", response.data);
      setState(data);
    } catch (error) {
      console.log("Error white fetching");
    }
  }
  async function LoadCity(stateId) {
    try {
      const response = await axiosInstance_user.get(
        `/dropdown/cities/${stateId}`
      );
      const data = response.data;
      console.log("State", response.data);
      setCity(data);
    } catch (error) {
      console.log("Error white fetching");
    }
  }
  useEffect(() => {
    if (stateId) {
      LoadCity(stateId);
    }
  }, [stateId]);

  useEffect(() => {
    LoadState();
  }, []);
  async function LoadReligion() {
    try {
      const response = await axiosInstance_user.get("/dropdown/choices");

      if (response.status === 200 && response.data) {
        console.log("religion", response.data.religion);
        setReligion(response.data.religion);
        // setMotherTongue(response.data.mother_tongue);
      } else {
        console.error("Unexpected response format or status", response);
      }
    } catch (error) {
      console.error("Failed to load religion data:", error.message);
    }
  }

  async function LoadCaste(religionId) {
    const response = await axiosInstance_user.get(
      `/dropdown/caste/${religionId}`
    );
    const data = response.data;
    console.log("caste", data);
    setCaste(data);
  }
  useEffect(() => {
    LoadReligion();
  }, []);

  useEffect(() => {
    if (religionId) {
      LoadCaste(religionId);
    }
  }, [religionId]);

  async function LoadSubCaste(casteId) {
    const response = await axiosInstance_user.get(
      `/dropdown/sub-caste/${casteId}`
    );
    const data = response.data;
    console.log("subcaste", data);
    setSubCaste(data);
  }
  useEffect(() => {
    if (casteId) {
      LoadSubCaste(casteId);
    }
  }, [casteId]);
  return (
    <form onSubmit={formik.handleSubmit}>
      {loading && (
        <div className="loader-overlay">
          <CircularProgress style={{ color: "#f24464" }} />
        </div>
      )}
      <div className="basicMainContainer">
        {/* Row 1 */}
        <div className="basicSubcontainer">
          <div>
            <div className="lableName">First Name</div>
            <div className="basicTextbox">
              <input
                type="text"
                name="first_name"
                onChange={formik.handleChange}
                value={formik.values.first_name}
                placeholder="Enter First Name"
              />
              {formik.touched.first_name && formik.errors.first_name && (
                <div className="text-danger">{formik.errors.first_name}</div>
              )}
            </div>
          </div>

          <div>
            <div className="lableName">Last Name</div>
            <div className="basicTextbox">
              <input
                type="text"
                name="last_name"
                onChange={formik.handleChange}
                value={formik.values.last_name}
                placeholder="Enter Last Name"
              />
              {formik.touched.last_name && formik.errors.last_name && (
                <div className="text-danger">{formik.errors.last_name}</div>
              )}
            </div>
          </div>
        </div>

        {/* Gender */}
        <div className="basicMainContainer">
          <div>
            <div className="lableName">Gender</div>
            <div className="basicRadio">
              <input
                type="radio"
                name="gender"
                value="1"
                onChange={formik.handleChange}
                checked={formik.values.gender === "1"}
              />
              <span>Male</span>
              <input
                type="radio"
                name="gender"
                value="2"
                onChange={formik.handleChange}
                checked={formik.values.gender === "2"}
              />
              <span>Female</span>
              <div>
                {formik.touched.gender && formik.errors.gender && (
                  <div className="text-danger">{formik.errors.gender}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* email and mobile number added  */}
        <div className="basicSubcontainer">
          <div>
            <div className="lableName">Email</div>
            <div className="basicTextbox">
              <input
                type="email"
                name="email"
                placeholder="Enter Email"
                onChange={formik.handleChange}
                value={formik.values.email}
              />
              {formik.touched.email && formik.errors.email && (
                <div className="text-danger">{formik.errors.email}</div>
              )}
            </div>
          </div>

          <div>
            <div className="lableName">Mobile Number</div>
            <div className="basicTextbox">
              <input
                type="text"
                name="mobile"
                placeholder="Enter Mobile Number"
                onChange={formik.handleChange}
                value={formik.values.mobile}
              />
              {formik.touched.mobile && formik.errors.mobile && (
                <div className="text-danger">{formik.errors.mobile}</div>
              )}
            </div>
          </div>
        </div>
        {/* Row 2 */}
        <div className="basicSubcontainer">
          <div>
            <div className="lableName">State Of Birth</div>
            <select
              name="state_of_birth"
              id="state_of_birth"
              value={formik.values.state_of_birth}
              onChange={(e) => {
                const selectedId = e.target.value;
                formik.setFieldValue("state_of_birth", selectedId);
                setStateId(selectedId);
                console.log("Selected State ID:", selectedId);
                // reset place_of_birth whenever state changes
                formik.setFieldValue("place_of_birth", "");
                setCity([]);
              }}
              onBlur={formik.handleBlur}
              className={`dropdown-btnBasic ${
                formik.touched.state_of_birth && formik.errors.state_of_birth
                  ? "error"
                  : ""
              }`}
            >
              <option value="" disabled>
                Select State
              </option>
              {state?.map((list) => (
                <option value={list.id} key={list.id}>
                  {list.name}
                </option>
              ))}
            </select>

            {formik.touched.state_of_birth && formik.errors.state_of_birth && (
              <div className="text-danger">{formik.errors.state_of_birth}</div>
            )}
          </div>

          <div>
            <div className="lableName">Place Of Birth</div>
            <select
              name="place_of_birth"
              id="place_of_birth"
              value={formik.values.place_of_birth}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`dropdown-btnBasic ${
                formik.touched.place_of_birth && formik.errors.place_of_birth
                  ? "error"
                  : ""
              }`}
            >
              <option value="" disabled>
                Select City
              </option>
              {city?.map((list) => (
                <option value={list.id} key={list.id}>
                  {list.name}
                </option>
              ))}
            </select>
            <div className="lableName" style={{ marginTop: "0px" }}>
              First select the state
            </div>
            {formik.touched.place_of_birth && formik.errors.place_of_birth && (
              <div className="text-danger">{formik.errors.place_of_birth}</div>
            )}
          </div>
        </div>

        {/* Row 3 */}
        <div className="basicSubcontainer">
          <div>
            <div className="lableName">Rasi</div>
            <select
              name="rasi"
              id="rasi"
              value={formik.values.rasi}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`dropdown-btnBasic ${
                formik.touched.rasi && formik.errors.rasi ? "error" : ""
              }`}
            >
              <option value="" disabled>
                Select Rashi
              </option>
              <option>Mesham</option>
              <option>Vrushabham</option>
              <option>Midhunam</option>
              <option>Karkatakam</option>
              <option>Simham</option>
              <option>Kanya</option>
              <option>Tula</option>
              <option>Vruschikam</option>
              <option>Dhanussu</option>
              <option>Makaram</option>
              <option>Kumbham</option>
              <option>Meenam</option>
            </select>
            {formik.touched.rasi && formik.errors.rasi && (
              <div className="text-danger">{formik.errors.rasi}</div>
            )}
          </div>

          <div>
            <div className="lableName">Nakshatra</div>
            <div className="basicTextbox">
              <select
                name="nakshatra"
                id="nakshatra"
                value={formik.values.nakshatra}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.nakshatra && formik.errors.nakshatra
                    ? "error"
                    : ""
                }`}
              >
                <option value="" disabled>
                  Select Nakshatra
                </option>
                <option>Anuraadha</option>
                <option>Arudra</option>
                <option>Ashlesha</option>
                <option>Ashwini</option>
                <option>Bharani</option>
                <option>Chittaa</option>
                <option>Dhanishta</option>
                <option>Asthami</option>
                <option>Jyesthaa</option>
                <option> Kritika</option>
                <option> Maghaa</option>
                <option>Mula</option>
                <option> Mrigasiraa</option>
                <option>Punarvasu</option>
                <option>Poorvashaadha</option>
                <option> Poorvabhadraa</option>
                <option>Pubba</option>
                <option>Pushya</option>
                <option> Revati</option>
                <option>Rohini</option>
                <option>Shatabhisha</option>
                <option>Shravana</option>
                <option>Swaati</option>
                <option>Uttarashaadha</option>
                <option> Uttaraa bhadra</option>
                <option>Uttara</option>
                <option>Vishaakha</option>
              </select>
              {formik.touched.nakshatra && formik.errors.nakshatra && (
                <div className="text-danger">{formik.errors.nakshatra}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 4 */}
        <div className="basicSubcontainer">
          <div>
            <div className="lableName">Religion</div>
            <select
              name="religion"
              id="religion"
              value={formik.values.religion}
              onChange={(e) => {
                const selectedId = e.target.value;
                formik.setFieldValue("religion", selectedId);
                setReligionId(selectedId);
                console.log("Selected Religion ID:", selectedId);
                // reset caste & sub caste whenever religion changes
                formik.setFieldValue("caste", "");
                formik.setFieldValue("sub_caste", "");
                setCaste([]);
                setSubCaste([]);
              }}
              onBlur={formik.handleBlur}
              className={`dropdown-btnBasic ${
                formik.touched.religion && formik.errors.religion ? "error" : ""
              }`}
            >
              <option value="" disabled>
                Select Religion
              </option>
              {religion.map((list) => (
                <option value={list.id} key={list.id}>
                  {list.name}
                </option>
              ))}
            </select>
            {formik.touched.religion && formik.errors.religion && (
              <div className="text-danger">{formik.errors.religion}</div>
            )}
          </div>

          <div>
            <div className="lableName">Caste</div>
            <select
              name="caste"
              id="caste"
              value={formik.values.caste}
              onChange={(e) => {
                const selectedId = e.target.value;
                formik.setFieldValue("caste", selectedId);
                setCasteId(selectedId);
                console.log("Selected Caste ID:", selectedId);
                // reset sub caste whenever caste changes
                formik.setFieldValue("sub_caste", "");

                setSubCaste([]);
              }}
              onBlur={formik.handleBlur}
              className={`dropdown-btnBasic ${
                formik.touched.caste && formik.errors.caste ? "error" : ""
              }`}
            >
              <option value="">Select Caste</option>
              {caste.map((list) => (
                <option value={list.id} key={list.id}>
                  {list.name}
                </option>
              ))}
            </select>

            <div className="lableName" style={{ marginTop: "0px" }}>
              First Select Religion
            </div>
            {formik.touched.caste && formik.errors.caste && (
              <div className="text-danger">{formik.errors.caste}</div>
            )}
          </div>
        </div>

        {/* Row 5 */}
        <div className="basicSubcontainer">
          <div>
            <div className="lableName">Sub Caste</div>
            <select
              name="sub_caste"
              id="sub_caste"
              value={formik.values.sub_caste}
              // onChange={(e) => {
              //   const selectedId = e.target.value;
              //   formik.setFieldValue("caste", selectedId);
              //   setCasteId(selectedId);
              //   console.log("Selected SubCaste ID:", selectedId);
              // }}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`dropdown-btnBasic ${
                formik.touched.caste && formik.errors.caste ? "error" : ""
              }`}
            >
              <option value="">Select Sub Caste</option>
              {subcaste.map((list) => (
                <option value={list.id} key={list.id}>
                  {list.name}
                </option>
              ))}
            </select>
            <div className="lableName" style={{ marginTop: "0px" }}>
              First Select Caste
            </div>
            {formik.touched.sub_caste && formik.errors.sub_caste && (
              <div className="text-danger">{formik.errors.sub_caste}</div>
            )}
          </div>
        </div>

        {/* Row 6 */}
        <div className="basicSubcontainer">
          <div>
            <div className="lableName">Gotra</div>
            <div className="basicTextbox">
              <input
                type="text"
                name="gotra"
                placeholder="Enter Gotra"
                onChange={formik.handleChange}
                value={formik.values.gotra}
              />
              {formik.touched.gotra && formik.errors.gotra && (
                <div className="text-danger">{formik.errors.gotra}</div>
              )}
            </div>
          </div>

          <div>
            <div className="lableName">Manglik</div>
            <div className="basicTextbox">
              <select
                name="manglik"
                id="manglik"
                value={formik.values.manglik}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`dropdown-btnBasic ${
                  formik.touched.manglik && formik.errors.manglik ? "error" : ""
                }`}
              >
                <option value="" disabled>
                  Select Manglik
                </option>
                <option value="1">Manglik</option>
                <option value="2">Non-manglik</option>
                <option value="3">Anshik manglik</option>
              </select>
              {formik.touched.manglik && formik.errors.manglik && (
                <div className="text-danger">{formik.errors.manglik}</div>
              )}
            </div>
          </div>
        </div>

        {/* Row 7 */}
        <div className="basicSubcontainer">
          <div>
            <div className="lableName">Height</div>
            <select
              name="height"
              id="height"
              value={formik.values.height}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`dropdown-btnBasic ${
                formik.touched.height && formik.errors.height ? "error" : ""
              }`}
            >
              <option value="" disabled>
                Select Height
              </option>
              <option value="4.00">4.00</option>
              <option value="4.01">4.01</option>
              <option value="4.02">4.02</option>
              <option value="4.03">4.03</option>
              <option value="4.04">4.04</option>
              <option value="4.05">4.05</option>
              <option value="4.06">4.06</option>
              <option value="4.07">4.07</option>
              <option value="4.08">4.08</option>
              <option value="4.09">4.09</option>
              <option value="4.10">4.10</option>
              <option value="4.11">4.11</option>

              <option value="5.00">5.00</option>
              <option value="5.01">5.01</option>
              <option value="5.02">5.02</option>
              <option value="5.03">5.03</option>
              <option value="5.04">5.04</option>
              <option value="5.05">5.05</option>
              <option value="5.06">5.06</option>
              <option value="5.07">5.07</option>
              <option value="5.08">5.08</option>
              <option value="5.09">5.09</option>
              <option value="5.10">5.10</option>
              <option value="5.11">5.11</option>

              <option value="6.00">6.00</option>
              <option value="6.01">6.01</option>
              <option value="6.02">6.02</option>
              <option value="6.03">6.03</option>
              <option value="6.04">6.04</option>
              <option value="6.05">6.05</option>
              <option value="6.06">6.06</option>
              <option value="6.07">6.07</option>
              <option value="6.08">6.08</option>
              <option value="6.09">6.09</option>
              <option value="6.10">6.10</option>
              <option value="6.11">6.11</option>

              <option value="7.00">7.00</option>
              <option value="7.01">7.01</option>
              <option value="7.02">7.02</option>
              <option value="7.03">7.03</option>
              <option value="7.04">7.04</option>
              <option value="7.05">7.05</option>
              <option value="7.06">7.06</option>
              <option value="7.07">7.07</option>
              <option value="7.08">7.08</option>
              <option value="7.09">7.09</option>
              <option value="7.10">7.10</option>
              <option value="7.11">7.11</option>
            </select>
            {formik.touched.height && formik.errors.height && (
              <div className="text-danger">{formik.errors.height}</div>
            )}
          </div>

          <div>
            <div className="lableName">Weight</div>
            <div className="basicTextbox">
              <input
                type="number"
                name="weight"
                placeholder="Enter Weight"
                onChange={formik.handleChange}
                value={formik.values.weight}
               min="0"
              />
              {formik.touched.weight && formik.errors.weight && (
                <div className="text-danger">{formik.errors.weight}</div>
              )}
            </div>
          </div>
        </div>

        <div className="btnBasicSave">
          <Button type="submit">Save Changes</Button>
        </div>

        {/* Success Modal */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
        >
          <Fade in={open}>
            <Box sx={style} className="modal-box">
              <img src={successImg} alt="Success" />
              <Typography variant="h6" component="h2">
                Thank You
              </Typography>
              <Typography id="transition-modal-description" sx={{ mt: 2 }}>
               Basic information has been updated successfully 
              </Typography>
            </Box>
          </Fade>
        </Modal>
      </div>
    </form>
  );
}
